import { render, staticRenderFns } from "./Spiner.vue?vue&type=template&id=203064f0&"
import script from "./Spiner.vue?vue&type=script&lang=js&"
export * from "./Spiner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports